import React from 'react';
import {OrderType} from "../../../../../../../../services/Api/types";
import OrderTypeIcon from "../../../../../../../../components/Common/OrderTypeIcon";
import {
    ReactComponent as BackgroundIco
} from "../../../../../../../../../images/backgrounds/multistore/other-types-bg.svg";
import {useTranslation} from "react-i18next";
import {ReactComponent as ArrowRightIco} from "../../../../../../../../../images/icons/arrow-right.svg";
import {useNavigate} from "react-router-dom";

interface Props {
    orderTypes: OrderType[];
}

const MultistoreWithMapHomePageOtherTypesSection = ({orderTypes}: Props) => {
    const finalOrderTypes = orderTypes.filter(orderType => orderType === OrderType.PICK_UP || orderType === OrderType.DINE_IN);
    const {t} = useTranslation();
    const typesTitle = finalOrderTypes.map(type => t(`enums.order.type.${type}`)).join(' / ');
    const navigate = useNavigate();

    return (
        <div className="multistore-with-map-home-page-other-types-section" onClick={() => navigate("/map")}>
            <div className="card">
                <div className="bg-container">
                    <div className="layer"/>
                    <BackgroundIco className="bg-icon"/>
                </div>
                <div className="card-container">
                    <div className="order-types">
                        {finalOrderTypes.map(orderType => (
                            <div className="order-type" key={orderType}>
                                <OrderTypeIcon orderType={orderType}/>
                            </div>
                        ))}
                    </div>
                    <div className="card-content">
                        <h5>{typesTitle}</h5>
                        <div className="card-content-bottom">
                            <p>{t("modules.multistore.field.choose_place.title")}</p>
                            <ArrowRightIco className="icon"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MultistoreWithMapHomePageOtherTypesSection;